import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Stack,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import { ChevronDownIcon } from '@/imports/ui/chakra/feather';

import { useAudience } from './hooks/useAudience';

export const AudienceMenu = React.forwardRef<
  HTMLButtonElement,
  {
    value: string | undefined;
    onChange: (value: string) => void;
    onBlur: () => void;
    isDisabled?: boolean;
  }
>((props, ref) => {
  const { loading, audiences } = useAudience();

  React.useEffect(() => {
    if (!loading && !props.value && audiences?.length) {
      props.onChange && props.onChange(audiences[0]._id);
    }
  }, [loading, audiences, props]);

  const selectedAudience = audiences?.find(
    (group) => group._id === props.value
  );

  return (
    <Box>
      <Menu placement="top-start">
        <MenuButton
          as={Button}
          isDisabled={loading || props.isDisabled}
          textAlign="left"
          w="full"
          variant="outline"
          colorScheme="gray"
          rightIcon={<ChevronDownIcon />}
          fontWeight="normal"
          onBlur={props.onBlur}
          ref={ref}
        >
          {selectedAudience ? (
            <Stack direction="row" align="center">
              <Text as="span" fontWeight="semibold" noOfLines={1}>
                {`${selectedAudience.name}  `}
              </Text>
              <Text>
                (
                {selectedAudience.totalMembers === 1
                  ? '1 person'
                  : `${selectedAudience.totalMembers} people`}
                )
              </Text>
            </Stack>
          ) : loading ? (
            'Loading...'
          ) : (
            'Select Audience'
          )}
        </MenuButton>
        <MenuList maxHeight={56} overflow="auto">
          <MenuOptionGroup
            type="radio"
            onChange={props.onChange}
            value={props.value}
          >
            {audiences?.map((audience) => (
              <MenuItemOption value={audience._id} key={audience._id}>
                <Text noOfLines={1}>{audience.name}</Text>
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
});

AudienceMenu.displayName = 'AudienceMenu';
